import React from 'react'

function projects() {
  return (
    <section className="builder_area mt-5 pt-5 pb-5 mb-5 col-11 col-lg-11 mx-auto">
    <div className="main_title mb-5">
      <h2>Nos Projects</h2>
      <p>Who are in extremely love with eco friendly system.</p>
    </div>
    <div className="row m0 builder_inner">
      <div className="builder_item col-lg-4 col-12 p-0">
        <img src="/builder-1.webp" alt=""/>
        <div className="hover ">
          <h4>Alex Complex for Residence</h4>
          <p>LCD screens are uniquely modern in style, and the liquid crystals that make them work have allowed humanity to create slimmer.</p>
        </div>
      </div>
      <div className="builder_item col-lg-4 col-12 p-0">
        <img src="/builder-2.webp" alt=""/>
        <div className="hover">
          <h4>Alex Complex for Residence</h4>
          <p>LCD screens are uniquely modern in style, and the liquid crystals that make them work have allowed humanity to create slimmer.</p>
        </div>
      </div>
      <div className="builder_item col-lg-4 col-12 p-0 m-0">
        <img src="/builder-3.webp" alt=""/>
        <div className="hover">
          <h4>Alex Complex for Residence</h4>
          <p>LCD screens are uniquely modern in style, and the liquid crystals that make them work have allowed humanity to create slimmer.</p>
        </div>
      </div>
      <div className="builder_item col-lg-4 col-12 p-0">
        <img src="/builder-4.webp" alt=""/>
        <div className="hover">
          <h4>Alex Complex for Residence</h4>
          <p>LCD screens are uniquely modern in style, and the liquid crystals that make them work have allowed humanity to create slimmer.</p>
        </div>
      </div>
      <div className="builder_item col-lg-4 col-12 p-0">
        <img src="/builder-5.webp" alt=""/>
        <div className="hover">
          <h4>Alex Complex for Residence</h4>
          <p>LCD screens are uniquely modern in style, and the liquid crystals that make them work have allowed humanity to create slimmer.</p>
        </div>
      </div>
      <div className="builder_item col-lg-4 col-12 p-0 m-0">
        <img src="/builder-6.webp" alt=""/>
        <div className="hover">
          <h4>Alex Complex for Residence</h4>
          <p>LCD screens are uniquely modern in style, and the liquid crystals that make them work have allowed humanity to create slimmer.</p>
        </div>
      </div>
    </div>
  </section>
  )
}

export default projects
